export default __webpack_public_path__ + "static/media/deconstruct-view-eye.900fea68.svg";